import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authSlice'
import activitiesReducer from './activitiesSlice'
import tasksReducer from './tasksSlice'
import tenantStatsReducer from './tenantStatsSlice'
import invoicesReducer from './invoicesSlice'
import campaignsReducer from './campaignsSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    activities: activitiesReducer,
    tasks: tasksReducer,
    tenantStats: tenantStatsReducer,
    invoices: invoicesReducer,
    campaigns: campaignsReducer,
  },
  // Disable serializable check for timestamps
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: ['payload.lastFetched'],
        ignoredStatePaths: ['auth.lastFetched', 'activities.lastFetched', 'tasks.lastFetch', 'tenantStats.lastFetched', 'invoices.lastFetched', 'campaigns.lastFetched'],
      },
    }),
  // Important: No persistence - we want fresh data every app load
  devTools: process.env.NODE_ENV !== 'production',
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Type-safe hooks
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

